var map = {
	"./20-May-the-road-rise-to-meet-you.mp3": 1023,
	"./23-Gastoldi-Amor-im-Nachen.mp3": 9871,
	"./24-Lasso-Mein-einiger-Trost.mp3": 9477,
	"./37-Obispo-Dahil-sa-iyo.mp3": 275,
	"./40-Morley-Now-is-the-month-of-Maying-Wdhl.mp3": 1441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1855;